'use client';
import PropTypes from 'prop-types';
import { DeletionModal } from '@components/DeletionModal/DeletionModal';
import { EditModal } from '@components/EditModal/EditModal';
import { ZoneForm } from '@components/FormComponents/ZoneForm/ZoneForm';
import { DeleteButton, EditButton } from '../split/TableActions';
import { deleteZone } from '@utils/graphql/creators/zones';
import { zoneDeleteWarning } from '@pages/split/utils/Constants';
import { MenuItem, Divider } from '@mui/material';
import { useRef } from 'react';
import '../split/TableActions.css';
import { handleTableActionsKeyDown } from '../split/utils/helpers';

export const ZoneActions = ({ rowInfo, id }) => {
  const editButtonRef = useRef(null);
  const deleteButtonRef = useRef(null);
  const buttonArray = [editButtonRef, deleteButtonRef];

  return [
    <MenuItem
      key='edit-zone-button'
      onKeyDown={(event) => {
        handleTableActionsKeyDown(event, buttonArray, 0);
      }}>
      <EditModal
        data={rowInfo}
        FormComponent={ZoneForm}
        fieldName='zone'
        trigger={({ handleOpen }) =>
          <EditButton
            ref={editButtonRef}
            focusIdOnEscape={id}
            handleOpen={handleOpen}
            data={rowInfo}
          />
        }
      />
    </MenuItem>,
    <Divider key='divider'/>,
    <MenuItem
      key='delete-zone-button'
      onKeyDown={(event) => {
        handleTableActionsKeyDown(event, buttonArray, 1);
      }}>
      <DeletionModal
        customMessage={zoneDeleteWarning}
        headerIcon='fa-solid fa-map-location-dot'
        data={rowInfo}
        handleDelete={deleteZone}
        fieldName='zone'
        trigger={({ handleOpen }) =>
          <DeleteButton
            ref={deleteButtonRef}
            focusIdOnEscape={id}
            handleOpen={handleOpen}
            data={rowInfo}
          />
        }
      />
    </MenuItem>,
  ];
};

ZoneActions.propTypes = {
  rowInfo: PropTypes.object,
  id: PropTypes.string,
};